<div class="gray-bg-rounded">
  <div class="today-task">
    <p-accordion value="0">
      <p-accordion-panel value="0">
        <p-accordion-header>
          <div class="d-flex justify-content-between topboder w-100">
            <span class="d-flex justify-content-between gap-2 align-items-top">
              <span><i class="pi pi-list-check"></i></span>
              <h2>
                To do List <jni-spinner *ngIf="showSmallLoader"></jni-spinner>
              </h2>
            </span>
            <span
              ><a
                (click)="showDialog()"
                class="text-decoration-none blue-text mx-2"
                >Add New</a
              ></span
            >
          </div>
        </p-accordion-header>
        <p-accordion-content>
          <div
            *ngIf="!showSmallLoader && todoLists.length > 0; else noList"
            class="box-height">
            <div
              *ngFor="let item of todoLists"
              class="col-lg-12 today-list-bar gray-bg">
              <div class="col-lg-12 d-flex justify-content-between">
                <h2>
                  <a (click)="editTodo(item)" href="javascript:;">{{
                    item.title
                  }}</a>
                </h2>
                <button
                  *ngIf="item.id"
                  (click)="deleteTodo(item.id)"
                  type="button"
                  class="bg-white text-black p-0"
                  pButton
                  icon="pi pi-trash"></button>
              </div>
              <div class="col-lg-12">
                <div class="time-bar">{{ item.description }}</div>
              </div>
            </div>
          </div>

          <ng-template #noList>
            <div class="col-lg-12 today-list-bar gray-bg">
              <div class="lds-ring inline me-auto ms-2" *ngIf="showSmallLoader">
                <div></div>
                <div></div>
                <div></div>
              </div>
              <h3 *ngIf="!showSmallLoader">No list available.</h3>
            </div>
          </ng-template>
        </p-accordion-content>
      </p-accordion-panel>
    </p-accordion>
  </div>

  <p-dialog
    [(visible)]="display"
    [style]="{ width: '25%', height: '35%', maxHeight: '100%' }"
    appendTo="body">
    <ng-template #header>
      <div class="has-border2">
        <h1 *ngIf="!isEdit" class="mb-0">Create own task</h1>
        <h1 *ngIf="isEdit" class="mb-0">Update task</h1>
      </div>
    </ng-template>
    <div [formGroup]="todoListForm" class="col-lg-12">
      <div class="col-12 mb-4">
        <div class="form-group has-float-label">
          <label class="form-label" for="Caccount"
            >Subject<span class="madatory-field">*</span></label
          >
          <input
            jniAutoCompleteBlocker
            pInputText
            type="text"
            class="form-control"
            formControlName="title" />
        </div>
      </div>

      <div class="col-12 mb-4">
        <div class="form-group has-float-label">
          <label class="form-label" for="Caccount"
            >Task<span class="madatory-field">*</span></label
          >
          <textarea
            pTextarea
            formControlName="description"
            class="w-full"
            cols="30"></textarea>
        </div>
      </div>

      <div class="col-lg-12 mt-3 d-flex gap-3 justify-content-end">
        <button
          pButton
          type="button"
          (click)="closeDialog()"
          label="Cancel"
          class="p-button-secondary p-button-sm p-button-outlined"></button>
        <button
          *ngIf="!isEdit"
          pButton
          type="button"
          label="Create Task"
          class="p-button-sm"
          (click)="createOrUpdateTodo()"></button>
        <button
          *ngIf="isEdit"
          pButton
          type="button"
          label="Update Task"
          class="p-button-sm"
          (click)="createOrUpdateTodo()"></button>
      </div>
    </div>
  </p-dialog>

  <jni-confirm-dialog
    [dialogMessage]="dialogMessage"
    dialogHeading="Delete Confirmation"
    *ngIf="deleteTodoVisible"
    (confirmDialogStatus)="deleteTodoItemById($event)">
  </jni-confirm-dialog>
</div>
